// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"6496ec05","403":"d84f5a2b","502":"39de8c4f","629":"981b802f","826":"1bc47cb5"}[chunkId] + ".chunk.js";
};